import React, { useState } from "react";
import { EdgeLabelRenderer, getSmoothStepPath } from "@xyflow/react";
import EdgeHoverHandler from "../EdgeHoverHandler";
import EdgeButtonsContainer from "../EdgeButtonsContainer";

const ConditionEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  target,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  // First vertical segment coordinates for label
  const labelPosX = sourceX;
  const labelPosY = (sourceY + targetY) / 2;

  // Second vertical segment coordinates for buttons
  const buttonPosX = targetX;
  const buttonPosY = (sourceY + targetY) / 2;

  const hasTarget = Boolean(target);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <>
      <EdgeHoverHandler
        edgePath={edgePath}
        markerEnd={markerEnd}
        style={style}
        id={id}
        strokeWidth={30}
        isHovered={isHovered}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />

      <EdgeLabelRenderer>
        {/* Condition Label */}
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelPosX}px,${labelPosY}px)`,
            pointerEvents: "all",
            backgroundColor:
              data?.label === "Yes" || data?.label === "Match"
                ? "#4caf50"
                : "#f44336",
            color: "white",
            padding: "2px 6px",
            borderRadius: "4px",
            fontSize: "10px",
            width: "60px",
            textAlign: "center",
            opacity: data?.label ? 1 : 0,
            fontWeight: "500",
          }}
          className="nodrag nopan"
        >
          {data?.label || ""}
        </div>

        {/* Buttons */}
        <EdgeButtonsContainer
          edgeId={id}
          target={target}
          labelX={buttonPosX}
          labelY={buttonPosY}
          isHovered={isHovered}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </EdgeLabelRenderer>
    </>
  );
};

export default ConditionEdge;
